// @ts-nocheck
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";

export const getFulfillmentLabel = (state: ApplicationState) => {
    const { fulfillmentMethod, shipToId, pickUpWarehouse } = getSession(state);
    const shipToState = getShipToState(state, shipToId);
    const { value: shipTo } = shipToState;
    /* Store Custom Code - Start */
    let addressLabel = "";
    if (fulfillmentMethod === FulfillmentMethod.Ship) {
        addressLabel = pickUpWarehouse
            ? `${pickUpWarehouse.city}, ${pickUpWarehouse.state}`
            : shipTo
              ? `${shipTo.companyName}`
              : "";
    } else if (fulfillmentMethod === FulfillmentMethod.PickUp) {
        addressLabel = pickUpWarehouse ? `${pickUpWarehouse.city}, ${pickUpWarehouse.state}` : "";
    }
    /* Store Custom Code - End */

    return addressLabel;
};
